// need tool or method
import { UtilsStore } from '@store/UtilsStore'
import { MainStore } from '@src/pages/main/store/MainStore'
import { BoardStore } from './BoardStore'

/**
 *
 * @author cardo
 * @description
 * sto-admin-front RootStore
 */
class RootStore {
  static instance: RootStore
  utilsStore: UtilsStore
  mainStore: MainStore
  boardStore: BoardStore

  constructor() {
    this.utilsStore = new UtilsStore()
    this.mainStore = new MainStore(this)
    this.boardStore = new BoardStore(this)
  }
}

export default RootStore
